import { render, staticRenderFns } from "./ServicesDetailPanel.vue?vue&type=template&id=709f0aa2&scoped=true&"
import script from "./ServicesDetailPanel.vue?vue&type=script&lang=js&"
export * from "./ServicesDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./ServicesDetailPanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ServicesDetailPanel.vue?vue&type=style&index=1&id=709f0aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f0aa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VSpacer,VToolbar})
